import { awsApiInstance } from '../api/aws-api';

import { INewCustomer, IPostCustomerResponse } from '../models/customer.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Posts new customer form data
 * 
 * @param {INewCustomer} customer  the form data
 * 
 * @returns {IPostCustomerResponse} the api response | error
 */
export const awsPostNewCustomer = async (customer: INewCustomer): Promise<IPostCustomerResponse> => {
  try {
    const { data } = await awsApiInstance.post('/customer', customer);

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error creating new customer');
    throw(error);
  }
}